import React, { useState, useEffect } from "react";
import "./InstallPopup.css"; // Arquivo CSS para estilização

const InstallPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    // Escuta o evento 'beforeinstallprompt'
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault(); // Previne o prompt automático
      setDeferredPrompt(event); // Salva o evento para uso posterior
      setIsVisible(true); // Exibe o popup
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt(); // Exibe o prompt de instalação
      const choiceResult = await deferredPrompt.userChoice;

      if (choiceResult.outcome === "accepted") {
        console.log("Usuário aceitou instalar o PWA");
      } else {
        console.log("Usuário rejeitou instalar o PWA");
      }

      setDeferredPrompt(null); // Limpa o evento
      setIsVisible(false); // Esconde o popup
    }
  };

  const handleClose = () => {
    setIsVisible(false); // Esconde o popup
  };

  return (
    isVisible && (
      <div className="install-popup">
        <div className="popup-content">
          <h2>Instale nosso App!</h2>
          <p>Adicione este aplicativo à sua tela inicial para acesso mais rápido e melhor experiência.</p>
          <button onClick={handleInstall}>Instalar</button>
          <button onClick={handleClose}>Fechar</button>
        </div>
      </div>
    )
  );
};

export default InstallPopup;
